import React, {useContext} from 'react';
import {Container, Text} from '@inlet/react-pixi';
import {RichTextTextStyle} from '@gongxigames/framework/core';
import {PayTableContext} from '@gongxigames/framework/slot/modules/oddsUpfront/OddsUpfrontReactView';

type PayContainerProps = {
    scale: number;
    symbolId: string;
    style: Partial<RichTextTextStyle>;
};

export function PayContainer({scale, symbolId, style}: PayContainerProps): JSX.Element {
    const st = {...style, fontSize: 110 * scale };
    const containers: JSX.Element[] = [];
    const {paytable} = useContext(PayTableContext).symbols[symbolId];
    const numberOfPays = paytable.filter(pay => pay > 0).length;
    const shouldReduce = new Set(paytable.filter(pay => pay > 0)).size === 1 && numberOfPays > 1;

    paytable.forEach((pay, payIndex) => {
        if (pay > 0) {
            if (shouldReduce && containers.length > 0) {
                return;
            }

            containers.push(
                <Container name={`amount_${payIndex}`} key={payIndex}>
                    <Text name='combo' style={st} text={`${payIndex}${shouldReduce ? '+' : 'x'}`}/>
                    <Text name='value' style={{...st, fill: 'white'}} text={`${pay}/1`} x={scale * 200}/>
                </Container>
            );
        }
    });

    return <>{containers.reverse()}</>;
}
